import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { DateFormatter } from '@repo/toolkit/date'
import Badge from '@repo/ui/badge'
import Typography from '@repo/ui/typography'

type Props = {
  label: string
  value?: Date | string
  type?: 'date' | 'string'
  variant?: 'badge' | 'none'
}

export function MTBadge({ label, value, type = 'string', variant = 'badge' }: Props) {
  const displayText =
    (typeof value !== 'string' || type === 'date') && value ? DateFormatter.DDMMYYYY(value) : value

  return (
    <div className={'flex flex-col gap-2 items-start'}>
      <Typography variant={'label-medium'} color={tailwindColors.grey.DEFAULT}>
        {label}
      </Typography>

      {!displayText ? (
        '-'
      ) : variant === 'badge' ? (
        <Badge size={'xsmall'} text={displayText} />
      ) : (
        <Typography variant={'label-medium'} color={tailwindColors.grey.DEFAULT}>
          {displayText}
        </Typography>
      )}
    </div>
  )
}
